export default {
    debounce(func, delay) {
        let inDebounce;
        return function () {
            const context = this;
            const args = arguments;
            clearTimeout(inDebounce);
            inDebounce = setTimeout(() => func.apply(context, args), delay);
        };
    },
    isInViewportCollection(elems, action) {
        $(elems).each((k, v) => {
            let distance = $(v).get(0).getBoundingClientRect();
            let offset = 0;
            if ($(v).data("offset") !== void 0) {
                offset = parseInt($(v).data("offset"));
            }
            if (distance.top >= 0 &&
                distance.left >= 0 &&
                distance.bottom <= (window.innerHeight || document.documentElement.clientHeight) - offset &&
                distance.right <= (window.innerWidth || document.documentElement.clientWidth)) {
                action(v);
            }
        });
    },
    isInViewport(elem, action) {
        let distance = $(elem).get(0).getBoundingClientRect();
        let offset = 0;
        if ($(v).data("offset") !== void 0) {
            offset = parseInt($(v).data("offset"));
        }
        if (distance.top >= 0 &&
            distance.left >= 0 &&
            distance.bottom <= (window.innerHeight || document.documentElement.clientHeight) - offset &&
            distance.right <= (window.innerWidth || document.documentElement.clientWidth)) {
            action(v);
        }
    }
};
